export class Deployment {
	public static hasDomainApiMetaRankingPercentageMember(value: unknown): boolean {
		return (
			typeof value === 'object' &&
			value !== null &&
			typeof value['getUniversityGlobalPositionPercentage'] === 'function'
		);
	}

	public static hasDomainApiGetEctsMember(value: unknown): boolean {
		return typeof value === 'object' && value !== null && typeof value['getEcts'] === 'function';
	}
}
